import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'RecommendSuggestion',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    errored: {
      type: Boolean,
      default: false
    },
    enableGenerateButton: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      text: '',
      generated: false,
      copyClicked: false,
      copied: false
    };
  },
  computed: {
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    },
    copyColour: function copyColour() {
      return this.theme.secondaryColor;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(value) {
        this.text = value;
      }
    },
    text: {
      immediate: true,
      handler: function handler(text) {
        this.copied = false;
        this.$emit('input', text);
      }
    }
  },
  mounted: function mounted() {
    window.addEventListener('mouseup', this.onMouseUp);
  },
  unmounted: function unmounted() {
    window.removeEventListener('mouseup', this.onMouseUp);
  },
  methods: {
    onGenerate: function onGenerate() {
      if (!this.generated) {
        this.$emit('generate');
      }

      this.generated = true;
    },
    onMouseUp: function onMouseUp() {
      this.copyClicked = false;
    },
    onCopy: function onCopy() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return navigator.clipboard.writeText(_this.text);

              case 3:
                _this.copied = true;

                _this.$emit('copy');

                _context.next = 9;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }))();
    }
  }
};